module.exports = __webpack_public_path__ + "img/loading-omni.0666b2fd.png";